import styled from "styled-components";

export const ContainerPagina = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;

  table {
    line-height: 16px;

    tr.tituloSecao {
      display: grid;
      grid-template-columns: 80% 20%;
      justify-content: space-between;
      font-size: 14px;
      border: none;
      margin-bottom: 4px;

      &.comSubtitulo {
        display: flex;
        grid-template-columns: none;
      }

      td {
        width: 100%;
        padding: 0;
      }

      * {
        font-size: 14px;
        line-height: 16px;
        border: none;
      }

      table {
        width: 100%;

        tbody {
          display: grid;
          grid-template-columns: 80% 20%;

          tr + tr {
            display: flex;
            align-items: flex-end;

            td {
              text-align: right;
            }
          }

          tr.subtituloSecao {
            display: flex;
            flex-direction: column;
            td {
              border: 1px solid black;
              font-size: 10px;
              text-align: left;
              padding: 4px;

              * {
                font-size: 10px;
              }

              &:nth-child(1) {
                border: none;
                display: grid;
                grid-template-columns: 60% 20% 20%;
                margin-bottom: 4px;
                padding: 0;

                span {
                  border: 1px solid black;
                  padding: 4px;

                  & + span {
                    border-left: none;
                  }
                  :nth-child(3) {
                    text-align: right;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FormFiltros = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  justify-content: left;
  align-items: flex-start;

  div {
    display: flex;
    margin-bottom: 5px;
    margin-top: 5px;
    width: 100%;
    max-width: 300px;

    @media only screen and (max-width: 1200px) {
      flex-direction: column;
    }
  }

  button {
    span,
    span * {
      font-size: 16px;
    }
  }
`;

export const AreaInfo = styled.table`
  width: 750px;
  margin: 5px auto;

  tr {
    display: flex;
    display: grid;
    grid-template-columns: 50% 50%;

    td {
      padding: 8px;
      border: solid 1px black;

      &.ministerioEconomia {
        display: flex;
        align-items: center;
        text-align: center;

        img {
          width: 70px;
        }
      }

      &.containerInfos {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-left: none;
        text-align: center;

        strong {
          margin-top: 15px;
        }
      }
    }
  }
`;

export const AreaObservacao = styled.section`
  width: 750px;
  margin: 5px auto;
  border: 1px solid black;
  text-align: center;
  padding: 0 10px;
`;

export const AreaFontePagadora = styled.table`
  width: 750px;
  margin: 5px auto;

  tr {
    display: grid;
    grid-template-columns: 25% 75%;

    td {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px;
      font-size: 10px;
      border: 1px solid black;
      line-height: 12px;

      & + td {
        border-left: none;
      }
    }
  }
`;

export const AreaBeneficiario = styled.table`
  width: 750px;
  margin: 8px auto;

  tr {
    &#dadosBeneficiario {
      display: grid;
      grid-template-columns: 25% 75%;

      td {
        border-bottom: none;
      }
    }

    td {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px;
      font-size: 10px;
      border: 1px solid black;
      line-height: 12px;

      strong {
        font-size: 10px;
      }
      & + td {
        border-left: none;
      }
    }
  }
`;

export const LinhasTabela = styled.table`
  width: 750px;
  margin: 8px auto;

  tr {
    display: grid;
    grid-template-columns: 80% 20%;

    &:nth-child(2) {
      border-top: 1px solid black;
    }

    td {
      padding: 4px;
      font-size: 10px;
      border: 1px solid black;
      border-top: none;
      * {
        font-size: 10px;
      }
      & + td {
        text-align: right;
        border-left: none;
      }
    }
  }
`;

export const AreaInfoComplementares = styled.table`
  width: 750px;
  margin: 8px auto;

  #espacoEmBranco {
    width: 100%;

    td {
      border: 1px solid black;
      height: 101px;
    }
  }
`;

export const AreaResponsavelInfo = styled.table`
  width: 750px;
  margin: 8px auto;

  tr {
    display: grid;
    grid-template-columns: 60% 10% 30%;

    td {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px;
      font-size: 10px;
      border: 1px solid black;
      line-height: 12px;

      span {
        font-size: 10px;
      }

      &#assinatura {
        justify-content: flex-start;
      }

      & + td {
        border-left: none;
      }
    }
  }
`;
